export default {
    'zh': require('./language/zh'),   // 中文语言包
    'en': require('./language/en'),   // English
}